<template>
  <van-uploader v-model="list" :accept="accept" multiple :max-count="maxCount" :after-read="onUploadAfterRead"
    :before-read="onUploadBeforeRead" image-fit="cover" :class="isShowEdit ? '' : 'info-page-class'">
    <template #preview-cover="{ url }">
      <template v-if="validFileType(url) === 'image'">
        <div class="image-box" @click.stop="viewImage(url)"></div>
      </template>
      <div v-else-if="url && validFileType(url) === 'video'" class="video-box">

        <template v-if="environment">
          <video height="80px" width="80px" controls>
            <source :src="url" type="video/mp4">
            <source :src="url" type="video/ogg">
            您的浏览器不支持Video标签。
          </video>
        </template>
        <template v-else>
          <video height="80px" width="80px" :ref="url">
            <source :src="url" type="video/mp4">
            <source :src="url" type="video/ogg">
            您的浏览器不支持Video标签。
          </video>
          <div class="play-box" @click.stop="palyVideo(url)"></div>
        </template>

      </div>
    </template>
  </van-uploader>
</template>
<script>
import { uploadOther } from "@/api/index";
import Compressor from "compressorjs";
import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
import Vue from "vue";
Vue.use(VueViewer);

//不需要响应式
const imageType = ["png", "jpg", "jpeg", "bmp", "gif"];
const videoType = ["mp4", "m2v", "mkv", "mov", "3gp"];

/**
 *  用法示例
 *    <TwiceUploads :fileList.sync="detail.images" />  上传页
 *    <TwiceUploads :fileList.sync="test" :isShowEdit="false" /> 详情页面
 */

export default {
  name: "TwiceUploads",
  props: {
    //  数据
    fileList: {
      type: Array,
      require: true,
      default: () => [],
    },
    // 文件类型
    accept: {
      type: String,
      default: "video/*,image/*",
    },
    // 是否需要编辑 详情页设为false
    isShowEdit: {
      type: Boolean,
      default: true,
    },
    // 上传数量限制
    maxCount: {
      type: Number,
      default: 9,
    },
  },
  data() {
    return {
      environment: navigator.userAgent.match(

        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i

      ) == null ? false : true
    };
  },
  computed: {
    list: {
      get() {
        // 这里看接口怎么处理 map一下就好了
        return this.fileList;
      },
      set(value) {
        this.$emit("update:fileList", value);
      },
    },
  },

  methods: {
    onUploadAfterRead(fileList) {
      fileList.forEach((file, index) => {
        if (!file.url) {
          file.status = "uploading";
          file.message = "上传中...";
          let formData = new FormData();
          formData.append("file", file.file);
          formData.append("module", "efficacy");
          formData.append("category", "track");
          // 加定时器是 因为 接口做了校验 多次请求
          setTimeout(() => {
            uploadOther(formData)
              .then((res) => {
                if (res.code == 0) {
                  file.status = "success";
                  file.message = "";
                  this.$set(file, 'url', res.data.absoluteUrl)
                  this.$forceUpdate()
                }
              })
              .catch((err) => {
                file.status = "failed";
                file.message = "上传失败";
                this.$forceUpdate()
              })
          }, index * 500);
        }
      });
    },
    async onUploadBeforeRead(file) {
      let fileList = [];
      if (!Array.isArray(file)) {
        fileList = [file];
      } else {
        fileList = [...file].slice(0, this.maxCount - this.list.length);
      }
      return await Promise.all(
        fileList.map((item) => {
          console.log(item)
          return new Promise((resolve) => {
            if (item.type.includes("image")) {
              // compressorjs 默认开启 checkOrientation 选项
              // 会将图片修正为正确方向
              new Compressor(item, {
                success: (result) => {
                  let newFile = new File([result], item.name, {
                    type: item.type,
                  });
                  resolve(newFile);
                },
                error(err) {
                  console.log(err.message);
                },
              });
            } else {
              resolve(item);
            }
          });
        })
      );
    },
    palyVideo(url) {
      const element = this.$refs[url]
      console.log(element)
      element.requestFullscreen();
      element.play();
    },

    validFileType(url = "") {
      const urlName = url.split(".").pop().toLocaleLowerCase();
      if (imageType.includes(urlName)) return "image";
      if (videoType.includes(urlName)) return "video";
      else return "";
    },

    viewImage(imgUrl) {
      let images = [];
      this.list.forEach((item) => {
        const urlName = (item.url || "").split(".").pop().toLocaleLowerCase();
        if (imageType.includes(urlName)) {
          images.push(item.url);
        }
      });
      let initialViewIndex = images.findIndex((item) => item === imgUrl);
      this.$viewerApi({
        images,
        options: {
          title: false,
          initialViewIndex,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.image-box {
  width: 100%;
  height: 100%;
  background: transparent;
}

.video-box {
  height: 100%;
  position: relative;
  background: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .play-box {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
}

.info-page-class {
  :deep(.van-uploader__upload) {
    display: none !important;
  }

  :deep(.van-uploader__preview-delete) {
    display: none !important;
  }
}
</style>